import React from 'react';

import middlewareFactory from '../middlewareFactory';

class Middleware extends React.Component {
    setWrapperElement = this.setWrapperElement.bind(this);

    componentDidMount() {
        this.middleware = middlewareFactory(this.wrapperElement, this.props.config);
        this.props.onPlayerReady(this.middleware);
    }

    componentWillUnmount() {
        this.middleware.destroy();
        this.middleware = null;
    }

    setWrapperElement(element) {
        this.wrapperElement = element;
    }

    render() {
        return (
            <div ref={this.setWrapperElement} />
        );
    }
}

export default Middleware;
